<template>
  <div>
    <!-- 기본정보 -->
    <field-select-module
      v-model="form.stdInfo"
      :board="this.board"
      :is-print="isPrint"
    />

    <!-- 추진계획 -->
    <div>
      <h5 class="my-4"><i class="dot"></i> 추진계획</h5>
      <div class="writeGridContainer">
        <div>
          <div>팀명</div>
          <p v-if="isPrint" class="print-input flex-1">{{ form.팀명 }}</p>
          <ml-input v-else :readonly="board.readonly" v-model="form.팀명" :max="100"/>
        </div>
      </div>

      <div class="writeGridContainer">
        <div>
          <div>실시목적</div>
          <p v-if="isPrint" class="print-input flex-1">{{ form.실시목적 }}</p>
          <ml-input v-else :readonly="board.readonly" v-model="form.실시목적" :max="100"/>
        </div>
      </div>

      <div class="writeGridContainer">
        <div class="writeGridLineItem">
          <div>실시방법</div>
          <span v-if="isPrint" class="print-textarea"> {{ form.실시방법 }} </span>
          <ml-textarea v-else rows="5" v-model="form.실시방법" :readonly="board.readonly" />
        </div>
      </div>
    </div>

    <table-custom
      :board="board"
      :is-print="isPrint"
      :controls="false"
      :multiple="false"
      thema="label"
      :tableData="[
        { id: 'type', title: '구분', type: 'string', width: '190px', backgroundColor: '#ffffff' },
        { id: 'rank', title: '직위', type: 'text', placeholder: '', width: '190px' },
        { id: 'name', title: '성명', type: 'text', placeholder: '', width: '190px' },
        { id: 'role', title: '역할', type: 'text', placeholder: '', max: 200 },
      ]"
      v-model="form.roleList"
      class="mt-28px"
    />

    <div class="mt-28px">
      <div class="writeGridContainer">
        <div class="writeGridLineItem">
          <div>실시방향</div>
          <span v-if="isPrint" class="print-textarea"> {{ form.실시방향 }} </span>
          <ml-textarea v-else rows="5" v-model="form.실시방향" :readonly="board.readonly" />
        </div>

        <div class="writeGridLineItem">
          <div>유의사항</div>
          <span v-if="isPrint" class="print-textarea"> {{ form.유의사항 }} </span>
          <ml-textarea v-else rows="5" v-model="form.유의사항" :readonly="board.readonly" />
        </div>
      </div>
    </div>

    <table-custom
      :board="board"
      :is-print="isPrint"
      title="위험성평가 실시계획"
      thema="label"
      :custom-thead="true"
      :table-data="[
        { id: 'name', title: '공정명', type: 'text', placeholder: '', max: 200 },
        { id: 'data1', type: 'customType', width: '80px' },
        { id: 'data2', type: 'customType', width: '80px' },
        { id: 'data3', type: 'customType', width: '80px' },
        { id: 'data4', type: 'customType', width: '80px' },
        { id: 'data5', type: 'customType', width: '80px' },
        { id: 'data6', type: 'customType', width: '80px' },
        { id: 'manager', title: '담당자', type: 'text', placeholder: '', width: '140px' },
        { id: 'director', title: '책임자', type: 'text', placeholder: '', width: '140px' },
      ]"
      :mobile="['name']"
      v-model="form.planList"
      class="mt-28px"
    >
      <template #customHead="{  isMobile, tableData, onClickAllCheck, allCheckValue }">
        <template v-if="isMobile">
          <th v-if="!isPrint" class="text-center">
            <vs-checkbox class="justify-center mx-0" :value="allCheckValue" @click.native="onClickAllCheck"/>
          </th>
          <th class="text-center">공정명</th>
          <th></th>
        </template>
        <template v-else>
          <!-- 테이블 헤더내 전체선택-->
          <th v-if="!isPrint" class="text-center" style="padding: 0">
            <vs-checkbox class="justify-center mx-0" :value="allCheckValue" @click.native="onClickAllCheck"/>
          </th>
          <!-- 테이블 헤더내 월 선택-->
          <th v-for="(th, index) in tableData" class="text-center" style="padding: 4px 0">
            <div v-if="th.title">{{th.title}}</div>
            <div v-else class="px-1">
              <div v-if="isPrint" class="print-input"> {{ form.planData[index-1] }}</div>
              <vs-select v-else v-model="form.planData[index-1]" class="w-full flex-1" autocomplete>
                <vs-select-item v-for="selectData in monthList" :key="selectData" :text="selectData" :value="selectData" />
              </vs-select>
            </div>
          </th>
        </template>
      </template>
      <!-- 테이블 바디내 월에 대한 값-->
      <template #customType="{ index, id, value, indexTd, isMobile }">
        <vs-select v-if="isMobile" v-model="form.planData[indexTd-1]" class="mb-2" autocomplete>
          <vs-select-item v-for="selectData in monthList" :key="selectData" :text="selectData" :value="selectData" />
        </vs-select>
        <div v-if="isPrint" class="print-input" :style="{ color: getColor(value) }"> {{ form.planList[index][id] }}</div>
        <vs-select v-else v-model="form.planList[index][id]" class="w-full flex-1" autocomplete :style="{ color: getColor(value) }">
          <vs-select-item v-for="selectData in ['-', 'P', 'D', 'C', 'A']" :key="selectData" :text="selectData" :value="selectData" />
        </vs-select>
      </template>
    </table-custom>


    <div class="mt-28px">
      <div class="writeGridContainer">
        <div class="writeGridLineItem">
          <div>비고</div>
          <span v-if="isPrint" class="print-textarea"> {{ form.비고 }} </span>
          <ml-textarea v-else rows="5" v-model="form.비고" :readonly="board.readonly" />
        </div>
      </div>
    </div>


    <!-- 파일첨부 -->
    <file-upload-module id="fileList" class="w-full mt-4" v-model="form.fileList" :is-print="isPrint" :readonly="board.readonly"></file-upload-module>
  </div>
</template>

<script>
import FileUploadModule from "@/views/modules/FileUploadModule";
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import TableInspectMerge from "@/components/TableInspectMerge";
import SignField from "@/components/SignField.vue";
import PhotoUploadGridModule from "@/views/modules/PhotoUploadGridModule.vue";
import NameWithSignatureRow from "@/components/NameWithSignatureRow.vue";
import TableCustom from "@/components/TableCustom.vue";

export default {
  components: {
    TableCustom,
    NameWithSignatureRow,
    PhotoUploadGridModule,
    SignField,
    TableInspectMerge,
    FieldSelectModule,
    FileUploadModule,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        this.$emit("input", value);

        if (this.form.planList.length === 0) {
          this.form.planList.push({
            id: 1,
            name: "",
            data1: "",
            data2: "",
            data3: "",
            data4: "",
            data5: "",
            data6: "",
            manager: "",
            director: "",
          });
        }
      },
    },
  },
  methods: {
    getColor(value) {
      switch (value) {
        case '-':
          return 'black';
        case 'P':
          return '#28C76F';
        case 'D':
          return '#FF9F43';
        case 'C':
          return '#EA5455';
        case 'A':
          return '#00CFE8';
        default:
          return 'black';
      }
    },
  },
  data() {
    return {
      monthList: ['1월', '2월', '3월', '4월', '5월', '6월', '7월', '8월', '9월', '10월', '11월', '12월'],
      form: {
        stdInfo: {},
        fileList: [],

        팀명: "",
        실시목적: "",
        실시방법: "",
        roleList: [
          {
            type: "담당자",
            rank: "",
            name: "",
            role: "·위험성평가 준비, 시행 및 결과 제출, 위험감소 계획수립, 시행결과보고",
          },
          {
            type: "책임자",
            rank: "",
            name: "",
            role: "·위험성평가 계획 및 결과, 위험감소 계획에 대한 검토 심의 및 승인",
          }
        ],

        실시방향: "·전체 공정을 대상으로 생산팀에서 시행하는 해당공정 점검/작업에 따른 정기 및 수시평가를 통해 근로자에게 미치는 유해위험 요인을 평가하여 체계적으로 관리 개선",
        유의사항: "·사전에 평가대상 목록 확정\n" +
          "·현장에서 위험에 직접 노출된 작업자 참여\n" +
          "·앗차사고 경험 반영·위험허용 수준은 업무특성 고려\n" +
          "·보유한 모든 정보 제공, 전문가 조언\n" +
          "·가능한 낮은 수준의 위험이 유지되도록 개선",

        planData: ['1월', '2월', '3월', '4월', '5월', '6월'],
        planList: [],
        비고: "·정보수집 : 분임활동\n" +
          "·개선 : 고위험순\n" +
          "·대책수립시\n" +
          " → 평가팀 의견 청취\n" +
          "·위험성 평가 활성화\n" +
          " 활동 전개\n" +
          "· 결과보존 : 3년이상",

      },
    };
  },
};
</script>

